import UnauthorizedView from "pages/PanelPage/components/UnauthorizedView/UnauthorizedView";

export default UnauthorizedView;
